import React from 'react';
import AntAuth from '../../../utils/AntAuth.js';
import './index.scss';
import { FaUserCircle } from 'react-icons/fa';

export default class AntPOSUserPanel extends React.Component {
    render() {
        const { menuMode, menuItems } = this.props;
        let userName = AntAuth.getSessionInfo('user_name');
        let empName = AntAuth.getSessionInfo('employee_name');
        let empFullName = AntAuth.getSessionInfo('employee_full_name');
        let txtName = [empFullName, empName, userName].filter((t) => Boolean(t)).shift();

        return (
            // <Button id={'userName'} className={'ant-main-header-user-button authorization'} width={30} height={'100%'} stylingMode={'text'}>
            <div className={'pos-user-panel'}>
                <div className={'pos-user-info'}>
                    <FaUserCircle className={'pos-user-image'} />
                    <div className={'pos-user-name'}>{txtName}</div>
                </div>
                {/* <ContextMenu items={menuItems} target={'.ant-main-header-user-button'} showEvent={'dxclick'} cssClass={'user-menu'}>
                        <Position my={'right top'} at={'right bottom'} target={window} />
                    </ContextMenu> */}
            </div>
            // </Button>
        );
    }
}
